<template>
    <AppModal @close="onClose()" v-bind="$attrs" v-if="visible">
        <template v-slot:header>Add Person to {{ organizationRoleName }}</template>
        <form @submit.prevent="onSubmit()">
            <transition name="fade">
                <AppNotification :type="alertMessage.type" v-if="alertMessage.message">
                    {{alertMessage.message}}
                </AppNotification>
            </transition>
            <div class="form-group">
                <label for="personId">Person</label>
                <select :class="{'is-invalid': $v.personId.$invalid}" class="form-control" v-model="personId">
                    <option :value="null" disabled>--Select Person--</option>
                    <option :key="person.id" :value="person.id" v-for="person in people">{{person.name}}</option>
                </select>
                <span class="invalid-feedback" v-if="!$v.personId.required">Field is required</span>
            </div>
        </form>
        <template v-slot:footer>
            <button :disabled="isSubmitting" @click.prevent="onSubmit()" class="btn btn-primary" type="submit">Save
            </button>
            <button :disabled="isSubmitting" @click="onClose()" class="btn btn-danger" data-dismiss="modal"
                    type="button">
                Close
            </button>
        </template>
    </AppModal>
</template>

<script>
    import AppModal from "../shared/AppModal";
    import PersonService from "@/services/PersonService";
    import OrganizationService from "@/services/OrganizationService";
    import AppNotification from "@/components/shared/AppNotification";
    import {required} from "vuelidate/lib/validators";
    import {ToastType} from "@/services/models/shared/ToastType";

    export default {
        components: {
            AppModal,
            AppNotification
        },
        data() {
            return {
                personId: null,
                isSubmitting: false,
                people: [],
                alertMessage: {
                    type: null,
                    message: null
                },
            }
        },
        props: {
            organizationId: {
                type: String,
                required: true
            },
            organizationRoleId: {
                type: String,
                required: true
            },
            organizationRoleName: {
                type: String,
                required: true
            },
            visible: {
                required: false,
                default: false
            }
        },
        watch: {
            visible() {
                this.personId = null;
            }
        },
        computed: {
            selectedPersonName() {
                return this.people.find(person => {
                    return person.id === this.personId
                }).name
            }
        },
        methods: {
            /**
             * @description Emits the close event to the parent
             */
            onClose() {
                this.$emit('close')
            },

            /**
             * @description Creates a new organization business role and emits the event to the parent
             */
            onSubmit() {
                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;
                OrganizationService.addOrganizationRole({
                    personId: vm.personId,
                    organizationId: vm.organizationId,
                    isPrimaryContact: false,
                    organizationRoleId: vm.organizationRoleId
                }).then(() => {
                    vm.alert(ToastType.Success, `${vm.selectedPersonName} was successfully added to the ${vm.organizationRoleName} role.`);

                    vm.$emit('create');
                    vm.onClose();
                }).catch(function (error) {
                    vm.alertMessage.type = "danger";
                    vm.alertMessage.message = error.response.statusText;
                }).finally(() => {
                    vm.isSubmitting = false;
                });
            }
        },
        created() {
            const vm = this;

            PersonService.getAllPeople()
                .then(response => {
                    vm.people = response
                }).catch((error) => {
                vm.alert(ToastType.Danger, error.response.statusText);

                vm.onClose();
            })
        },
        validations: {
            personId: {
                required
            }
        }
    }
</script>
